<template>
  <v-container py-0 fluid>
    <Navbar
      :hasDrawer="true"
      :title="`Pedidos (${pedidos.length})`"
    >
      <template slot="actions">
        <v-btn
          icon
          :loading="loading"
          @click="getPedidosAPI"
        ><v-icon>mdi-cached</v-icon>
        </v-btn>
        <v-btn
          icon
          :loading="syncLoading"
          @click="sendPedidosAPI"
        ><v-icon>mdi-database-sync</v-icon>
        </v-btn>
        <v-btn
          icon
          @click.stop="filterDrawer = !filterDrawer"
        ><v-icon>mdi-filter-variant</v-icon>
        </v-btn>
      </template>
    </Navbar>
    <v-navigation-drawer
      v-model="filterDrawer"
      absolute
      temporary
    >
      <h4 class="text-center py-3">Filtros</h4>
      <v-divider></v-divider>
      <v-container>
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-select
              dense
              v-model="orderSelected"
              hide-details
              label="Ordenar por"
              :items="orderItems"
            ></v-select>
          </v-col>
          <!-- <v-col cols="12" class="py-0">
            <v-subheader class="pl-0 font-weight-bold">Status</v-subheader>
            <v-checkbox
              v-model="statusSelected"
              label="Pendente"
              value="A"
              hide-details
              class="mt-0"
            ></v-checkbox>
            <v-checkbox
              v-model="statusSelected"
              label="Finalizado"
              value="F"
              hide-details
            ></v-checkbox>
          </v-col> -->
          <!-- <v-col cols="12" class="pb-0">
            <v-divider></v-divider>
          </v-col> -->
          <v-col cols="12">
            <v-btn
              text
              @click.stop="filterDrawer = false"
            >Cancelar</v-btn>
            <v-btn
              color="primary"
              @click.stop="applyFilters"
            >Aplicar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-list
          v-if="computedPedidos.length"
          class="pa-0"
          three-line
          :style="pedidosContainer"
        >
          <v-list-item
            v-for="(pedido, i) in computedPedidos"
            :key="i"
            @click="$router.push(`/pedidos/${pedido.id_saida}`)"
            class="px-0"
          >
            <v-list-item-avatar :class="$vuetify.breakpoint.xs ? 'ma-auto' : ''">
              <StatusIcon :text="statusText(pedido)" :color="statusColor(pedido)" />
            </v-list-item-avatar>
            <v-list-item-content :class="i !== computedPedidos.length -1 ? 'pb-0' : ''">
              <v-col cols="10" md="6" class="pa-0">
                <v-list-item-title class="font-weight-medium body-2">
                  <v-icon small>mdi-pound</v-icon>
                  {{ pedido.id_saida }}
                </v-list-item-title>
              </v-col>
              <v-col cols="10" md="4" class="pa-0">
                <v-list-item-title class="font-weight-medium body-2">
                  <v-icon small>mdi-account</v-icon>
                  {{ pedido.cliente }}
                </v-list-item-title>
              </v-col>
              <v-col cols="12" md="6" offset-md="0" class="pa-0">
                <v-list-item-title class="caption">
                  <v-icon small>mdi-calendar</v-icon>
                  {{ pedido.emissao | dateMonthYear }}
                </v-list-item-title>
              </v-col>
              <v-divider v-if="i !== computedPedidos.length - 1" :key="i"></v-divider>
            </v-list-item-content>
            <v-list-item-action class="ma-auto">
              <v-btn icon>
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <p v-else class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
        <p v-if="error" class="text-center font-weight-bold red--text mt-4 mb-0">{{ error }}</p>
        <div class="text-center mt-3" id="pagination">
          <v-pagination
            v-model="page"
            :length="totalPages"
            circle
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { pedidoService } from '@/services/pedidoService';
import StatusIcon from '@/components/shared/StatusIcon';

export default {
  name: 'Home',
  components: {
    StatusIcon
  },
  data: () => ({
    filterDrawer: false,
    item: 1,
    page: 1,
    loading: false,
    syncLoading: false,
    orderItems: ['id_saida', 'cliente', 'emissao'],
    orderSelected: 'id_saida',
    statusSelected: ['A'],
    filters: {
      order: 'id_saida',
      status: ['P']
    },
    error: ''
  }),
  computed: {
    ...mapGetters([
      'pedidos',
      'permiteQtdeDivergente',
    ]),
    pedidosContainer() {
      const offset = 80;
      const bodyHeight = document.body.clientHeight;
      const firstRowDiv = document.getElementById('first-row');
      const firstRowHeight = firstRowDiv ? firstRowDiv.clientHeight : 0;
      const paginationDiv = document.getElementById('pagination');
      const paginationHeight = paginationDiv ? paginationDiv.clientHeight : 44;
      const barrasContainerHeight = bodyHeight - firstRowHeight - paginationHeight - offset;
      return {
        maxHeight: barrasContainerHeight.toString() + 'px',
        overflow: 'auto'
      }
    },
    computedPedidos() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      return this.pedidos
        .slice(start, end)
        .sort((a, b) => a[this.filters.order] > b[this.filters.order] ? 1 : -1);
        // .filter(item => this.filters.status.includes(item.status))
    },
    totalPages() {
      // const total = this.pedidos
      //   .filter(item => this.filters.status.includes(item.status)).length / 10;
      const total = this.pedidos.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
  methods: {
    ...mapActions(['fetchPedidos', 'fetchPedidosAPI', 'fetchUnidades', 'fetchUnidadesAPI']),
    ...mapMutations(['SHOW_SNACKBAR']),
    statusText(pedido) {
      if (pedido && pedido.qtde_realizada === pedido.qtde_prevista) return 'mdi-checkbox-blank-circle';
      return 'mdi-checkbox-blank-circle-outline';
    },
    statusColor(pedido) {
      if (pedido && pedido.qtde_realizada === pedido.qtde_prevista) return 'success';
      return '';
    },
    loadLocalConfig() {
      const configPedidos = localStorage.getItem('configPedidos');
      if (configPedidos) {
        const { order } = JSON.parse(configPedidos);
        this.orderSelected = order;
        // this.statusSelected = status;
        this.filters.order = order;
        // this.filters.status = status;
      }
    },
    saveLocalConfig() {
      localStorage.setItem('configPedidos', JSON.stringify({
        order: this.orderSelected,
        // status: this.statusSelected
      }));
    },
    async sendPedidosAPI() {
      if (this.pedidos && this.pedidos.length) {
        this.syncLoading = true;
        // Valida quantidade divergente
        if (!this.permiteQtdeDivergente) {
          try {
            await this.sendPedidosFinalizados();
            this.syncLoading = false;
            this.SHOW_SNACKBAR({ text: 'Sincronização concluída com sucesso!', status: 'success' });
          } catch (error) {
            this.syncLoading = false;
            this.SHOW_SNACKBAR({ text: 'Ocorreu um erro ao sincronizar os pedidos!', status: 'error' });
          }
        } else {
          try {
            await this.sendPedidos();
            this.syncLoading = false;
            this.SHOW_SNACKBAR({ text: 'Sincronização concluída com sucesso!', status: 'success' });
          } catch (error) {
            this.syncLoading = false;
            this.SHOW_SNACKBAR({ text: 'Ocorreu um erro ao sincronizar os pedidos!', status: 'error' });
          }
        }
      }
    },
    async sendPedidosFinalizados() {
      const pedidosFinalizados = this.pedidos.filter(pedido => pedido.qtde_prevista === pedido.qtde_realizada);
      await pedidoService.sendPedidos(pedidosFinalizados);
    },
    async sendPedidos() {
      const pedidos = this.pedidos.filter(pedido => pedido.qtde_realizada > 0);
      await pedidoService.sendPedidos(pedidos);
    },
    async getPedidosAPI() {
      this.loading = true;
      try {
        await this.fetchPedidosAPI();
        await this.fetchUnidadesAPI();
        this.error = '';
        this.loading = false;
        this.SHOW_SNACKBAR({ text: 'Lista atualizada com sucesso', status: 'success' });
      } catch (error) {
        this.error = error;
        this.loading = false;
        this.SHOW_SNACKBAR({ text: 'Ocorreu um erro ao atualizar a lista!', status: 'error' });
      }
    },
    async getPedidos() {
      if (!this.pedidos.length) {
        this.loading = true;
        try {
          await this.fetchPedidos();
          await this.fetchUnidades();
          this.error = '';
          this.loading = false;
          // this.SHOW_SNACKBAR({ text: 'Lista atualizada com sucesso', status: 'success' });
        } catch (error) {
          this.error = error;
          this.loading = false;
          this.SHOW_SNACKBAR({ text: 'Ocorreu um erro ao atualizar a lista!', status: 'error' });
        }
      }
    },
    applyFilters() {
      this.filters.order = this.orderSelected;
      // this.filters.status = this.statusSelected;
      this.filterDrawer = false;
      this.saveLocalConfig();
    },
  },
  created() {
    this.loadLocalConfig();
    this.getPedidos();
  }
}
</script>
